import * as React from 'react';
import classNames from 'classnames';
import style from './tag.scss';

type SpanElementProps = JSX.IntrinsicElements['span'];
type AnchorElementProps = JSX.IntrinsicElements['a'];
type ComposedProps = SpanElementProps & AnchorElementProps;

export interface TagProps extends ComposedProps {
  tag: string;
  link?: string;
}

export function Tag({
  tag = '',
  link = '',
  className = '',
  ...restProps
}: TagProps) {

  const tagProps = {
    className: classNames(className, style.tag, {
      [style.link]: Boolean(link),
    }),
    ...restProps,
  };

  if (link) {
    tagProps.href = link;
  }

  return React.createElement(
    link ? 'a' : 'span',
    tagProps,
    tag,
  );
}

export default Tag;
